import { S3Client } from '@aws-sdk/client-s3'
import { AwsSdkModule } from '@backend/aws'
import { Module } from '@nestjs/common'
import { S3Config } from '../../config'

@Module({
	imports: [AwsSdkModule.register({ isGlobal: true, client: new S3Client(S3Config) })],
})
export class AwsModule {}
